import { Provider, Providers } from 'components/types/LocationTypes';
import React from 'react';
import Texts from '../../../assets/utils/texts';
import LocationProvider from './LocationProvider';

type LocationProvidersProps = {
	providers: Providers;
	allProviders: string;
};

const LocationProviders = (props: LocationProvidersProps): JSX.Element => {
	const { providers, allProviders } = props;
	const sortedProviders: Array<Provider> = JSON.parse(allProviders);
	const specialtyGroups = providers.SpecialtyGroups;

	return (
		<>
			<div id="providers" className="profile-section location-providers">
				<div className="content">
					<h2 className="osf-inner-h2">
						{Texts.Providers} <span className="provider-count">{providers?.ProviderCount}</span>
					</h2>
					<ul className="link-list">
						{sortedProviders.map((provider) => {
							const specialty = Object.entries(specialtyGroups).find(([_, arr]) =>
								arr.some(
									(prov) =>
										prov.FullNameAndCredentials === provider.FullNameAndCredentials &&
										prov.ProfileUrl === provider.ProfileUrl &&
										prov.ProviderImage === provider.ProviderImage
								)
							);
							let key = '';
							if (specialty) {
								[key] = specialty;
							}
							if (specialty) {
								return (
									<LocationProvider provider={provider} specialty={specialty} specialtyName={key} />
								);
							} else {
								return <></>;
							}
						})}
					</ul>
				</div>
			</div>
		</>
	);
};

export default LocationProviders;
